import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';

/**
 * [CW-PERSON-REFACTOR] Generic CRUD service of {@code cw.CwCasePersonRole}
 * ({@code /mvsa/cw/casePersonRoles}) — the CASE-level role occupancy.
 *
 * <h3>[WP-Q][M1] Why both neighbours carry a qualifier</h3>
 * There are two services about the same entity, and the bare name {@code CwCasePersonRoleService}
 * belongs to NEITHER of them — deliberately, because it would be injectable by mistake in place of
 * either. Each one says in its name what it does:
 * <ul>
 *   <li>this class, {@code ...CrudService} — row access for one {@code cw.CwCasePersonRole} through
 *       the framework's generic entity surface;</li>
 *   <li>{@code CwCasePersonRoleQueryService} — the QL READ SEAM answering "who holds what", over BOTH
 *       levels ({@code cw.CwCasePersonRole} and {@code cw.CwCaseProductPersonRole}).</li>
 * </ul>
 * They are not interchangeable: injecting the CRUD service where a step wants the occupancy question
 * answers one row and no roles, and it compiles.</p>
 *
 * <h3>Reads, not writes</h3>
 * The frontend does not create or delete role rows through this service. They are written
 * server-side together with the participation rows, the re-anchored value bag and the derived
 * {@code owner}/{@code insured} projection; a client-side write would leave those inconsistent.
 * Registered here so the alias resolves at all — an unregistered alias answers an empty list rather
 * than failing, which is indistinguishable from "this person holds no role".
 */
@Injectable({
    providedIn: 'root',
})
export class CwCasePersonRoleCrudService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/casePersonRoles');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
